import { Map as MapImmutable } from 'immutable';
import {
  SET_LAST_TIME_PING_SERVER,
  SET_LAST_TIME_INTERACT_UI,
  PING_SERVER_START,
  PING_SERVER_SUCCESS,
  PING_SERVER_FAILURE,
  IS_CATI_SESSION_ACTIVE_FAILURE,
  IS_CATI_SESSION_ACTIVE_SUCCESS,
  IS_CATI_SESSION_ACTIVE_START,
  IS_PARTICIPANT_PROFILE,
  END_CATI_ACTIVE_SESSION_START,
  END_CATI_ACTIVE_SESSION_SUCCESS,
  END_CATI_ACTIVE_SESSION_FAILURE,
  GET_LIST_SURVEYS_START,
  GET_LIST_SURVEYS_SUCCESS,
  GET_LIST_SURVEYS_FAILURE,
} from './events';
import { ERROR_MESSAGE } from '../../constants';

const initialState = new MapImmutable({});
const actionHandlers = {};
/**
 * SET_LAST_TIME_PING_SERVER
 * @param {Object} state Current state
 * @param {Object} action
 * @return {Object} Next state
 */
actionHandlers[SET_LAST_TIME_PING_SERVER] = (state, action) =>
  state.set('lastTimePingServer', action.time);

/**
 * SET_LAST_TIME_PING_SERVER
 * @param {Object} state Current state
 * @param {Object} action
 * @return {Object} Next state
 */
actionHandlers[SET_LAST_TIME_INTERACT_UI] = (state, action) =>
  state.set('lastTimeUpdatedUI', action.time);
/**
 * SET_LAST_TIME_PING_SERVER
 * @param {Object} state Current state
 * @param {Object} action
 * @return {Object} Next state
 */
actionHandlers[PING_SERVER_START] = state =>
  state.set('requesting', true);
/**
 * SET_LAST_TIME_PING_SERVER
 * @param {Object} state Current state
 * @param {Object} action
 * @return {Object} Next state
 */
actionHandlers[PING_SERVER_SUCCESS] = state =>
  state.set('requesting', false);
/**
 * SET_LAST_TIME_PING_SERVER
 * @param {Object} state Current state
 * @param {Object} action
 * @return {Object} Next state
 */
actionHandlers[PING_SERVER_FAILURE] = state =>
  state.set('requesting', false);

/* Tracked separately from lastTimePingServer, which the global fetch wrapper bumps on every
   API call in the app - gating this poll on that shared timestamp meant unrelated traffic
   (autosave, participant loads, etc.) during a CATI interview kept starving this specific
   check, so catiSessionStatus could go unpolled for far longer than the intended ~1 minute
   (AC-156452). */
/* 'catiRequesting' is tracked separately from 'requesting' (used by PING_SERVER_*): both used
   to write the same key, so refreshSession()'s single guard against overlapping requests meant
   a slow/hung ping request could block the CATI poll (and vice versa) indefinitely, since
   neither fetch has a timeout (AC-156452). */
actionHandlers[IS_CATI_SESSION_ACTIVE_START] = (state, action) => state
  .set('isCATIActive', true)
  .set('catiRequesting', true)
  .set('lastTimeCatiSessionChecked', action.time);
/**
 * SET_LAST_TIME_PING_SERVER
 * @param {Object} state Current state
 * @param {Object} action
 * @return {Object} Next state
 */
actionHandlers[IS_CATI_SESSION_ACTIVE_SUCCESS] = (state, action) => state
  .set('isCATIActive', action.response.Status)
  .set('catiRequesting', false);
/**
 * SET_LAST_TIME_PING_SERVER
 * @param {Object} state Current state
 * @param {Object} action
 * @return {Object} Next state
 */
actionHandlers[IS_CATI_SESSION_ACTIVE_FAILURE] = state => state
  .set('isCATIActive', true)
  .set('catiRequesting', false);

actionHandlers[IS_PARTICIPANT_PROFILE] = (state, action) => state
  .set('isParticipantProfile', action.response);

/**
 * END_CATI_ACTIVE_SESSION_START
 * @param {Object} state Current state
 * @return {Object} Next state
 */
actionHandlers[END_CATI_ACTIVE_SESSION_START] = state =>
  state
    .delete('endCATISessions');

/**
* END_CATI_ACTIVE_SESSION_SUCCESS
* @param {Object} state Current state
* @param {Object} action
* @return {Object} Next state
*/
actionHandlers[END_CATI_ACTIVE_SESSION_SUCCESS] = (state, action) =>
  state
    .set('endCATISessions', action.response.endSession);

/**
* END_CATI_ACTIVE_SESSION_FAILURE
* @param {Object} state Current state
* @return {Object} Next state
*/
actionHandlers[END_CATI_ACTIVE_SESSION_FAILURE] = state =>
  state
    .delete('endCATISessions');

// GET_LIST_SURVEYS
actionHandlers[GET_LIST_SURVEYS_START] = state => state
  .set('requestingSurveysList', true)
  .delete('surveyListError');

actionHandlers[GET_LIST_SURVEYS_SUCCESS] = (state, action) => state
  .set('requestingSurveysList', false)
  .set('surveyList', action.response.catiFormItemDTOs)
  .set('lastRefreshed', action.response.lastRefreshTimestamp);

actionHandlers[GET_LIST_SURVEYS_FAILURE] = state => state
  .set('requestingSurveysList', false)
  .delete('surveyList')
  .delete('lastRefreshed')
  .set('surveyListError', ERROR_MESSAGE);

/**
 * Action Handlers
 * @param {Object} state Current state
 * @param {Object} action
 * @return {Object} Next state
 */
export default (state = initialState, action) => {
  if (actionHandlers[action.type] !== undefined) {
    const nextState = actionHandlers[action.type](state, action);
    if (nextState === null || nextState === undefined) {
      return state;
    }
    return nextState;
  }
  return state;
};
